import { UnumButton } from "ui-library";
import { Content, Wrapper } from "./ReportError.styles";
import RefreshArrow from "../../../assets/icons/RefreshArrow.svg";
import useGetUser from "../../../hooks/useGetUser";

type reportErrorProps = { onRetry?: () => void };
const ReportError = ({ onRetry }: reportErrorProps) => {
  const { hasCashPlanAccess, hasEmployerAccess } = useGetUser();
  const isCashplanOnlyUser = hasCashPlanAccess && !hasEmployerAccess;

  const errorTitle = isCashplanOnlyUser ? "No data available" : "Dashboard not available";

  const errorBodyContent = isCashplanOnlyUser ? (
    <p>We're working on it - Help@hand analytics for Health Plan 360 are coming soon.</p>
  ) : (
    <>
      <p>
        We couldn’t load this dashboard due to an unexpected error.
        <br />
        Please try again later or use the chat icon to contact us.
      </p>
      <UnumButton
        onClick={() => onRetry?.()}
        label="Retry"
        startIcon={<RefreshArrow />}
        size="small"
        style={{
          width: "fit-content",
          backgroundColor: "var(--unumBlueDark)",
        }}
      />
    </>
  );
  return (
    <Wrapper>
      <Content>
        <h1>{errorTitle}</h1>
        {errorBodyContent}
      </Content>
    </Wrapper>
  );
};

export default ReportError;
